/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BatchRequest {
    getFixupPrototypeFunction() { return BatchRequest.fixupPrototype; }

    static newInstance(model: Partial<BatchRequest>): BatchRequest {
        let obj = Object.assign(new BatchRequest(), model);
        BatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BatchRequest>): BatchRequest {
        if (!model) return null;
        return BatchRequest.newInstance(<BatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BatchRequest) {
        if (!obj) return;

        models.BatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BatchRequest): boolean {
        Object.setPrototypeOf(obj, BatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifiers to fetch
     */
    ids: Array<string>;

}
